interface EvaluationProgressBarProps {
    percentage: number;
}

export const EvaluationProgressBar = ({ percentage }: EvaluationProgressBarProps) => {
    return (
        <div className={'bg-growth-tint h-3 w-full rounded-full'}>
            <div
                className={'bg-primary h-full rounded-full transition-all'}
                style={{ width: `${percentage}%` }}
            />
        </div>
    );
};
